// app/composables/useDockTransitionDir.ts

export type DockTransitionDir = "left" | "right"

/**
 * Global state controlling the Dock tab slide direction.
 *
 * "left": new page enters from the right, old page leaves to the left
 * "right": new page enters from the left, old page leaves to the right
 */
export const useDockTransitionDir = () =>
    useState<DockTransitionDir>("dockTransitionDir", () => "left")
